var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.52793C5.10999 2.52793 1.95652 5.68141 1.95652 9.57141C1.95652 13.4614 5.10999 16.6149 9 16.6149C12.89 16.6149 16.0435 13.4614 16.0435 9.57141C16.0435 5.68141 12.89 2.52793 9 2.52793ZM0 9.57141C0 4.60085 4.02944 0.571411 9 0.571411C13.9706 0.571411 18 4.60085 18 9.57141C18 14.542 13.9706 18.5714 9 18.5714C4.02944 18.5714 0 14.542 0 9.57141Z",
    fill: "#6171FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02174 8.00619C9.1023 8.00619 9.97826 8.88216 9.97826 9.96272V13.2888C9.97826 13.8291 9.54028 14.2671 9 14.2671C8.45972 14.2671 8.02174 13.8291 8.02174 13.2888V8.00619Z",
    fill: "#6171FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1739 6.04967C10.1739 6.69801 9.64833 7.22359 9 7.22359C8.35167 7.22359 7.82609 6.69801 7.82609 6.04967C7.82609 5.40134 8.35167 4.87576 9 4.87576C9.64833 4.87576 10.1739 5.40134 10.1739 6.04967Z",
    fill: "#6171FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.423c0cdb.svg";
export { ForwardRef as ReactComponent };